let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2oek8")).then(() => parcelRequire('6Tp14'));